var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tag-label min-w-12",class:[{
            'active-tag-label' :!_vm.disabled && _vm.type === 'default',
            'disabled-tag-label' :_vm.disabled,
            'tag-inactive': _vm.type === 'inactive',
        },
        _vm.tagClasses,
      ],attrs:{"disable-transitions":_vm.disableTransitions}},[_c('span',{staticClass:"flex items-center",class:_vm.innerClass},[(_vm.$slots.icon || _vm.icon)?_c('span',{staticClass:"tag-icon",class:_vm.iconClass},[_vm._t("icon",function(){return [_c(_vm.icon,{tag:"component"})]})],2):_vm._e(),_c('span',{class:_vm.contentClasses,style:(_vm.contentStyles)},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }